export default __webpack_public_path__ + "static/media/result.e6a456f2.svg";